"use client"

import { useLocale } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { useSuspenseQuery } from '@apollo/client';

import { getListingsVariables } from '@/components/listings/api_utils';
import { getInitialSearchState } from '@/utils';
import { SearchListingsQuery } from '@/query';
import { useSearchFromUrl } from '@/components/base/SearchListing';
import { ListingsList } from './Listing';

export const Listings = () => {
  const locale = useLocale();
  useSearchFromUrl();
  const query = {};
  const params = useSearchParams();
  params.forEach((value, key) => (query[key] = value));

  const page = Number(query.page || 1);

  const {
    date,
    inexactStay,
    pets,
    guests,
    location,
    price,
    amenities,
    rooms,
    rating,
    tab,
  } = getInitialSearchState(query);

  const variables = getListingsVariables(
    inexactStay,
    guests,
    location,
    pets,
    date,
    price,
    amenities,
    rooms,
    rating,
    tab,
  );

  const { data } = useSuspenseQuery(
    SearchListingsQuery,
    {
      variables: {
        ...variables,
        locale,
        limitValue: 20,
        page,
      },
      errorPolicy: 'ignore',
    }
  )

  const nextPage = data?.availableListings?.metadata?.totalPages > page
    ? page + 1
    : null;

  return (
    <>
      <ListingsList initialData={data} nextPage={nextPage} />
    </>
  );
};
